import React from 'react';
import './TextInputCounter.css';

const TextInputCounter = ({ charsRemaining, show }) => {
  if (show) {
    return (
      <span className="textInputCounter">{charsRemaining} characters left.</span>
    );
  } else {
    return null;
  }
};

export default TextInputCounter;



// WEBPACK FOOTER //
// ./src/components/TextInputCounter/index.js